export default __webpack_public_path__ + "static/media/House_of_Ankha_NH.045d0897.jpeg";